module.exports = __webpack_public_path__ + "img/69-l.a8ed6f73.png";